import { render } from "./ResetPasswordToken.vue?vue&type=template&id=100aa682"
import script from "./ResetPasswordToken.vue?vue&type=script&lang=js"
export * from "./ResetPasswordToken.vue?vue&type=script&lang=js"

import exportComponent from "/home/websites/repositories/macgear-scanner/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__